module.exports = __webpack_public_path__ + "favicon-96x96.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=[name].[ext]!./src/favicon-96x96.png
// module id = 145
// module chunks = 0